module.exports = __webpack_public_path__ + "static/media/Lateral_ES_Z2.8cb98067.png";